(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-verification"]) return;
  try {
    
  class AgeVerification {
    constructor() {
      this.cookieName = 'age_verified';
      this.cookieExpireDays = 365;
      this.popup = document.getElementById('age-verification-popup');
      this.acceptBtn = document.getElementById('age-verification-accept');
      this.rejectBtn = document.getElementById('age-verification-reject');
      this.buttonsContainer = document.getElementById('age-verification-buttons');
      this.titleEl = document.querySelector('.age-verification-popup__title');
      this.textEl = document.querySelector('.age-verification-popup__text');

      this.init();
    }

    init() {
      if (this.isAgeVerified()) {
        this.hidePopup();
      } else {
        this.showPopup();
        this.attachEventListeners();
      }
    }

    attachEventListeners() {
      this.acceptBtn.addEventListener('click', () => this.handleAccept());
      this.rejectBtn.addEventListener('click', () => this.handleReject());
    }

    handleAccept() {
      try { sessionStorage.setItem(this.cookieName, 'true'); } catch (e) {}
      this.hidePopup();
    }

    handleReject() {
      this.buttonsContainer.style.display = 'none';
      const forbiddenTitle = this.popup.getAttribute('data-forbidden-title');
      const forbiddenDesc = this.popup.getAttribute('data-forbidden-description');
      this.titleEl.textContent = forbiddenTitle;
      this.textEl.textContent = forbiddenDesc;
    }

    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = 'expires=' + date.toUTCString();
      document.cookie = name + '=' + value + ';' + expires + ';path=/';
    }

    getCookie(name) {
      const nameEQ = name + '=';
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(nameEQ) === 0) {
          return cookie.substring(nameEQ.length);
        }
      }
      return null;
    }

    isAgeVerified() {
      try { return sessionStorage.getItem(this.cookieName) === 'true'; } catch (e) { return false; }
    }

    hidePopup() {
      if (this.popup) {
        this.popup.classList.add('hidden');
        document.documentElement.style.overflow = '';
      }
    }

    showPopup() {
      if (this.popup) {
        this.popup.classList.remove('hidden');
        document.documentElement.style.overflow = 'hidden';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new AgeVerification();
    });
  } else {
    new AgeVerification();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banners"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
